import { useEffect } from "react";
import Link from "next/link";

import { useFetchProjectListing } from "modules/projects/api";

import { apiUrls } from "config";

import Tag from "ui-components/Tag";
import Button from "ui-components/Button";

import { useGetUserDetails } from "auth/auth-state";
import { ShareEntity } from "lib/permissions";

import config from "flows/notebook-analysis/config";
import NotebookAnalysisSummary from "flows/notebook-analysis/elements/Context-Summary";
import NotebookAnalysisDataSummary from "flows/notebook-analysis/elements/Data-File-Summary";

const Listing = () => {
  const userDetails = useGetUserDetails();
  const [data, status, hasNextPage, getNextPage] = useFetchProjectListing(
    config.FLOW_NAME
  );

  useEffect(() => {
    hasNextPage && getNextPage();
  }, [getNextPage, hasNextPage, data]);

  const listing = data.flat();
  return (
    <div>
      <p className="text-right">
        <Link href={"/notebook-analysis/create"}>
          <Button className="text-right">Create New Project</Button>
        </Link>
      </p>
      {listing.length >= 1 && (
        <table className="table table-auto w-full">
          <thead>
            <tr>
              <th className="font-semibold text-left table-cell w-1/6">
                <p className="px-1 mx-1">Creation Details</p>
              </th>
              <th className="font-semibold text-left table-cell w-1/2">
                <p className="px-1 mx-1">Project</p>
              </th>
              <th className="font-semibold text-left table-cell">
                <p className="px-1 mx-1">Context</p>
              </th>
            </tr>
          </thead>
          <tbody>
            {data.flat().map((d) => (
              <tr key={d.id} className="table-row border-t-2">
                <td className="table-cell">
                  <div className="m-1">
                    <p>
                      {new Date(d.created_time).toLocaleDateString(undefined, {
                        hour: "numeric",
                        minute: "numeric",
                        hour12: true,
                      })}
                    </p>
                  </div>
                </td>
                <td className="table-cell">
                  <p className="m-1">
                    <Link href={`/${d.flow}/${d.id}`}>
                      <a className="text-primary-main">
                        {d.name ? (
                          <span>
                            <span className="font-bold">{d.name}</span> ({d.id})
                          </span>
                        ) : (
                          <span className="font-bold">{d.id}</span>
                        )}
                      </a>
                    </Link>
                  </p>
                  {d.owner === userDetails?.email ? (
                    <div className="flex">
                      <div className="p-1">
                        <ShareEntity
                          entityId={d.id}
                          baseUrl={apiUrls.projects}
                          entityName="Project"
                          size="small"
                        />
                      </div>
                      {/* <div className="p-1">
                        <Rename projectId={d.id} currentName={d.name} />
                      </div>
                      <div className="p-1">
                        <Delete projectId={d.id} />
                      </div> */}
                    </div>
                  ) : (
                    <div className="flex flex-wrap">
                      <Tag className="text-base">Shared by {d.owner}</Tag>
                    </div>
                  )}
                </td>
                <td className="table-cell">
                  <div className="m-1">
                    <NotebookAnalysisDataSummary project={d} />
                    <NotebookAnalysisSummary project={d} />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Listing;
